<template>
  <div>
    <el-badge
      :value="notReadMessageCount"
      :max="99"
      :hidden="!notReadMessageCount"
    >
      <el-button class="chatroom-btn" :class="theme" @click="visible = true">
        <i class="iconfont icon-chatroom m-r-4 font-22"></i>
        开标对话
      </el-button>
    </el-badge>

    <el-dialog
      :id="visible"
      title="开标对话"
      width="70%"
      class="chat-dialog"
      top="5vh"
      :visible.sync="visible"
      :close-on-click-modal="false"
      append-to-body
    >
      <template v-slot:title>
        <div class="flex">
          <div class="flex col-center font-18 dialog-title">
            <i class="iconfont icon-chatroom m-r-4"></i>
            开标对话
          </div>
          <div class="flex-1 text-ellipsis p-h-14 font-18">
            {{ currentChatRoom.title }}
          </div>
        </div>
      </template>

      <div class="dialog-content flex">
        <div class="content-left">
          <div v-if="!isSupplier" class="p-20">
            <el-input
              v-model="chatRoomSearchText"
              placeholder="请输入投标单位名称"
              clearable
            />
          </div>

          <el-scrollbar
            class="scrollbar-y-hidden"
            :style="`height: ${isSupplier ? '100%' : 'calc(100% - 72px)'}`"
          >
            <div
              v-for="item in chatPartnerList"
              :key="item.title"
              class="chat-partner"
              :class="{
                active:
                  currentChatRoom.receiverCompanyId === item.receiverCompanyId
              }"
              @click="changeChatRoom(item)"
            >
              <div class="flex">
                <div class="flex-1 text-ellipsis text-bold m-r-8">
                  {{ item.title }}
                </div>
                <el-badge
                  v-if="
                    notReadMessageObj[item.receiverCompanyId] &&
                      currentChatRoom.receiverCompanyId !==
                      item.receiverCompanyId
                  "
                  :value="notReadMessageObj[item.receiverCompanyId]"
                  :max="99"
                />
              </div>
              <template
                v-if="item.msgSessionType === msgSessionTypeDict.PRIVATE.value"
              >
                <div
                  v-if="!isSupplier"
                  class="flex text-third-info m-t-8 font-12"
                >
                  <span class="flex-1">联系人：{{ item.contactUserName }}</span>
                  <span class="flex-1">
                    联系电话：{{ item.contactUserPhone }}
                  </span>
                </div>
              </template>
            </div>
          </el-scrollbar>
        </div>

        <div class="content-right flex-1">
          <el-scrollbar ref="chatContentScroll" class="scrollbar-y-hidden">
            <!--向上滚动查看历史信息的loading-->
            <i
              v-if="historyLoading"
              class="history-loading el-icon-loading"
            ></i>

            <div
              ref="chatContent"
              class="chat-content"
              @click="clickListener($event)"
            >
              <!--聊天信息-->
              <div
                v-for="message in messageList"
                :key="message.msgId"
                class="chat-list"
              >
                <div class="send-time">{{ message.sendTime }}</div>

                <div
                  class="chat-bubble flex col-top"
                  :class="{
                    self: message.senderCompanyId === companyId
                  }"
                >
                  <div
                    class="avatar flex row-center col-center"
                    :class="`${senderTypeDict[message.senderType].alias}-bg`"
                  >
                    {{ senderTypeDict[message.senderType].label }}
                  </div>
                  <div class="chat-message flex-1">
                    <div class="sender text-info">
                      {{ message.senderCompanyName }}
                    </div>
                    <div
                      v-if="message.msgContent"
                      v-dompurify-html="message.msgContent"
                      class="send-message m-t-8"
                    ></div>
                    <div v-else class="send-message m-t-8">
                      <upload
                        :file-id-before="message.attachmentId"
                        :props-data="{
                          uploadMode: 'fileId',
                          disabled: true,
                          fileListHiddenControl: {
                            hiddenUploadBtn: false,
                            hiddenReUploadBtn: false
                          }
                        }"
                      >
                        <template v-slot:tip><div></div></template>
                      </upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--回到底部-->
            <div
              v-if="showNewBtn"
              class="news-btn flex row-center col-center"
              @click="
                showNewBtn = false
                controlChatScrollFun()
              "
            >
              <i class="iconfont icon-pointer-down m-r-5"></i>
              你有新消息
            </div>
          </el-scrollbar>

          <div class="chat-input flex flex-col col-bottom">
            <!--可以聊天时的展示-->
            <template v-if="canGroupChat">
              <el-scrollbar
                class="flex-1 scrollbar-y-hidden"
                style="width: 100%"
              >
                <u-editor
                  v-model="messageText"
                  class="self-input"
                  :config="{
                    toolbars: [],
                    elementPathEnabled: false,
                    wordCount: false,
                    initialFrameHeight: 0,
                    retainOnlyLabelPasted: true,
                    filterTxtRules: filterTxtRules()
                  }"
                  :use-simsun="false"
                  @click.native="inputGetFocus"
                />
              </el-scrollbar>

              <div class="m-t-2 flex">
                <upload
                  :file-id-before.sync="messageAttachmentId"
                  :props-data="{
                    uploadMode: 'fileId',
                    multiple: false,
                    fileListHiddenControl: {
                      hiddenFileList: true
                    }
                  }"
                >
                  <template v-slot:btn="{ progress }">
                    <div class="flex">
                      <i class="el-icon-folder-add font-20"></i>
                      <span
                        v-if="progress"
                        class="m-l-4 font-12 text-third-info"
                      >
                        <i class="el-icon-loading"></i>
                        {{ progress }}%
                      </span>
                    </div>
                  </template>
                  <template v-slot:tip>
                    <div style="height: 0px;"></div>
                  </template>
                </upload>

                <el-button
                  :type="canGroupChat ? 'primary' : 'info'"
                  size="mini"
                  :disabled="!messageText"
                  class="m-r-16"
                  @click="sendMessage(1)"
                >
                  发送
                </el-button>
              </div>
            </template>

            <!--不可聊天时的展示-->
            <div
              v-else
              class="flex-1 flex col-center row-center"
              style="width: 100%"
            >
              {{ chatDisabledTip }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--聊天窗中图片的全屏查看-->
    <el-image-viewer
      v-if="samplePictureDialog"
      :on-close="() => (samplePictureDialog = false)"
      :url-list="[samplePictureUrl]"
      z-index="3000"
    />
  </div>
</template>

<script>
// 组件
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import UEditor from '@/components/common/UEditor/index.vue'
import Upload from '@/components/common/Upload/index.vue'

// 后端api接口
import {
  sendMessageInChatroomApi,
  getChatMessageInChatroomApi,
  setMessageReadInChatroomApi,
  getMessageStatisticalDataApi,
  sendMessageInChatroomBySupplierApi,
  getChatMessageInChatroomBySupplierApi,
  setMessageReadInChatroomBySupplierApi,
  getMessageStatisticalDataBySupplierApi
} from '@/api/hall/bid-open-hall.js'

// 数据字典
const senderTypeDict = {
  1: { label: '招', value: 1, alias: 'purchaser' },
  2: { label: '投', value: 2, alias: 'supplier' }
}
const msgSessionTypeDict = {
  GROUP: { label: '群聊', value: 0 },
  PRIVATE: { label: '私聊', value: 1 }
}
import { kpbProjectStatusDict } from '@/dictionary/project/kpb-project'

// 工具函数
import { scrollMainTo } from '@/utils/scroll-to.js'
import { mapState } from 'vuex'
import { bidInviteBidStatusDict } from '@/dictionary/project/bid'

export default {
  name: 'BidChatroom',

  components: {
    ElImageViewer,
    UEditor,
    Upload
  },

  props: {
    projectId: {
      type: [String, Number],
      default: ''
    },

    // 投标id，供应商开标大厅使用
    bidderId: {
      type: [String, Number],
      default: ''
    },

    projectStatus: {
      type: [String, Number],
      default: ''
    },

    orderStatus: {
      type: [String, Number],
      default: ''
    },

    isSupplier: {
      type: Boolean,
      default: false
    },

    theme: {
      validator: function(value) {
        return ['dark', 'light'].indexOf(value) !== -1
      },
      default: 'dark'
    },

    // 供应商列表
    supplierList: {
      type: Array,
      default: () => []
    },

    // 采购人（公告发布者）
    purchaserInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    // 不需要监听变化的字段
    this.senderTypeDict = senderTypeDict
    this.msgSessionTypeDict = msgSessionTypeDict

    return {
      // 控制对话框的显隐
      visible: false,
      notReadMessageCount: 0, // 总的未查看的聊天记录数量
      notReadMessageObj: {}, // 记录每个聊天室的未读个数
      chatRoomSearchText: '', // 过滤聊天室

      // 聊天信息
      currentChatRoom: {},
      messageText: '',
      messageAttachmentId: '',
      messageList: [],
      messageObject: {}, // 记录msgId，去除因轮询和及时请求导致的消息重复

      // 回到底部按钮
      showNewBtn: false,
      // 查看历史消息的loading
      historyLoading: false,

      // 计时器
      timer: null,
      duration: 2000,

      // 图片全屏查看变量
      samplePictureDialog: false,
      samplePictureUrl: '',

      // 滚动到最底部的误差值
      scrollErrorValue: 5
    }
  },

  computed: {
    ...mapState('company', ['companyId']),

    // 发送消息接口
    sendMessageInChatroomApi() {
      return this.isSupplier
        ? sendMessageInChatroomBySupplierApi
        : sendMessageInChatroomApi
    },

    // 获取消息列表接口
    getChatMessageInChatroomApi() {
      return this.isSupplier
        ? getChatMessageInChatroomBySupplierApi
        : getChatMessageInChatroomApi
    },

    // 设置消息已读接口
    setMessageReadInChatroomApi() {
      return this.isSupplier
        ? setMessageReadInChatroomBySupplierApi
        : setMessageReadInChatroomApi
    },

    // 获取消息统计数据 （未读消息个数）
    getMessageStatisticalDataApi() {
      return this.isSupplier
        ? getMessageStatisticalDataBySupplierApi
        : getMessageStatisticalDataApi
    },

    // 控制是否可以群聊
    canGroupChat() {
      if (this.isSupplier) {
        return (
          this.projectStatus >= kpbProjectStatusDict.OPEN_BID_STARTED.value &&
          this.orderStatus < bidInviteBidStatusDict.CANDIDATE_PUBLISHED.value
        )
      }
      return this.orderStatus < bidInviteBidStatusDict.CANDIDATE_PUBLISHED.value
    },

    // 侧标的聊天对象列表
    chatPartnerList() {
      return !this.isSupplier
        ? [
          {
            title: `全部投标单位（${this.supplierList?.length || 0}）`,
            msgSessionType: msgSessionTypeDict.GROUP.value,
            receiverCompanyId: ''
          },
          ...(this.supplierList || []).map(value => {
            return {
              title: value.supplierName,
              msgSessionType: msgSessionTypeDict.PRIVATE.value,
              receiverCompanyId: value.supplierId,
              contactUserName: value.contactUserName,
              contactUserPhone: value.contactUserPhone
            }
          })
        ].filter(
          value =>
            value.msgSessionType === msgSessionTypeDict.GROUP.value ||
              value.title.includes(this.chatRoomSearchText.trim())
        )
        : [
          {
            title: `全部投标单位`,
            msgSessionType: msgSessionTypeDict.GROUP.value,
            receiverCompanyId: ''
          },
          {
            title: this.purchaserInfo.purchaseCompanyName,
            msgSessionType: msgSessionTypeDict.PRIVATE.value,
            receiverCompanyId: this.purchaserInfo.purchaseCompanyId
          }
        ]
    },

    chatDisabledTip() {
      if (
        this.orderStatus >= bidInviteBidStatusDict.CANDIDATE_PUBLISHED.value
      ) {
        return '项目已发布候选，不支持发送消息'
      }
      if (this.orderStatus === bidInviteBidStatusDict.CLOSED.value) {
        return '项目流标，不支持发送消息'
      }
      return '开标未开始，不支持发送消息'
    }
  },

  watch: {
    chatPartnerList(val) {
      if (
        this.currentChatRoom?.msgSessionType === msgSessionTypeDict.GROUP.value
      ) {
        this.currentChatRoom = val[0] || {}
      }
    },

    // 监听聊天框的显隐
    // 置消息已读只有在聊天框显隐时处理，显示时只是通过逻辑不展示未读消息数量；已减少轮询请求
    visible: {
      handler: function(val) {
        if (val) {
          this.setUEditorImgStyle()
          this.addScrollListener()
        }
      }
    },

    // 监听开评标状态
    orderStatus: {
      handler: function(val) {
        if (Number(val) < bidInviteBidStatusDict.CANDIDATE_PUBLISHED.value) {
          this.loopFun()
        } else {
          this.timer && clearTimeout(this.timer)
        }
      },
      immediate: true
    },

    // 监听，如果有附件id则触发消息发送
    messageAttachmentId(val) {
      if (val) {
        this.sendMessage(2)
      }
    }
  },

  created() {
    this.currentChatRoom = this.chatPartnerList[0] || {}
    this.getNotReadMessageCount()
    this.getMessageList()
  },

  beforeDestroy() {
    this.timer && clearTimeout(this.timer)
  },

  methods: {
    /**
     * 复制去除样式
     */
    filterTxtRules() {
      function transP(node) {
        node.tagName = 'p'
        node.setStyle()
      }
      return {
        // 直接删除及其字节点内容
        '-': 'script style object iframe embed input select',
        p: { $: {} },
        br: { $: {} },
        div: { $: {} },
        li: { $: {} },
        caption: { $: {} },
        th: { $: {} },
        tr: { $: {} },
        h1: { $: {} },
        h2: { $: {} },
        h3: { $: {} },
        h4: { $: {} },
        h5: { $: {} },
        h6: { $: {} }
      }
    },

    /**
     * 切换聊天室
     */
    changeChatRoom(item) {
      if (this.currentChatRoom.receiverCompanyId !== item.receiverCompanyId) {
        this.currentChatRoom = item
        this.messageList = []
        this.messageObject = {}
        this.getMessageList()
      }
    },

    /**
     * 输入框获取焦点
     */
    inputGetFocus() {
      const iframe = document.querySelector('.edui-editor-iframeholder iframe')
      iframe?.contentWindow?.document?.body?.focus()

      // 生成一个style元素，设置img样式
      const style = document.createElement('style')
      style.type = 'text/css'
      style.appendChild(
        document.createTextNode('img{max-height:400px;max-width:400px;}')
      )
      iframe?.contentWindow?.document?.head?.appendChild(style)
    },

    /**
     * 给百度富文本增加img的样式，组件私用，不要设置在百度富文本全局
     */
    setUEditorImgStyle() {
      this.$nextTick(() => {
        const iframe = document.querySelector(
          '.edui-editor-iframeholder iframe'
        )
        // 生成一个style元素，设置img样式
        const style = document.createElement('style')
        style.type = 'text/css'
        style.appendChild(
          document.createTextNode('img{max-height:400px;max-width:400px;}')
        )
        iframe?.contentWindow?.document.body.appendChild(style)
      })
    },

    /**
     * 设置监听事件
     */
    addScrollListener() {
      this.$nextTick(() => {
        this.$refs.chatContentScroll.wrap.addEventListener(
          'scroll',
          this.scrollListener
        )
        this.controlChatScrollFun(0)
      })
    },

    /**
     * 监听聊天气泡的点击事件
     * @param e
     */
    clickListener(e) {
      const temp = e?.target || {}

      if (temp?.tagName?.toLowerCase() === 'img') {
        this.samplePictureDialog = true
        this.samplePictureUrl = temp?.src || ''
      }
    },

    /**
     * 开启轮询
     * 当聊天框从隐藏到显示时，将轮询逻辑从获取未读消息数量，到轮询最新消息
     * 当聊天框从显示到隐藏时，将轮询逻辑从获取最新消息，到未读消息数量
     */
    loopFun() {
      this.timer && clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.getNotReadMessageCount()
        this.visible && this.getMessageList()

        this.loopFun()
      }, this.duration)
    },

    /**
     * 获取当前未读消息个数
     */
    getNotReadMessageCount() {
      this.getMessageStatisticalDataApi({}, this.projectId, this.bidderId)
        .then(res => {
          let notReadMessageSum = 0

          ;(res?.data || []).forEach(value => {
            notReadMessageSum += value.notReadCnt

            if (value.msgSessionType === msgSessionTypeDict.PRIVATE.value) {
              this.notReadMessageObj[value.chatCompanyId] = value.notReadCnt
            } else {
              this.notReadMessageObj[''] = value.notReadCnt
            }
          })

          this.notReadMessageCount = notReadMessageSum
          this.$emit('getNotReadMessageCount', notReadMessageSum)
        })
        .catch(() => {})
    },

    /**
     * 获取聊天信息，默认获取最新信息，但是
     * loadDir: up|down, up为向上滚动查看历史数据，down为向下滚动查看最新数据
     * self: Boolean, 请求自己发送出去的数据
     */
    getMessageList(loadDir = 'down', self = false) {
      loadDir === 'up' && (this.historyLoading = true)

      const size =
        this.notReadMessageObj[this.currentChatRoom.receiverCompanyId] || 0

      const temp = {
        size: loadDir === 'down' ? (size >= 10 ? size : 10) : 20,
        msgSessionType: this.currentChatRoom.msgSessionType,
        chatCompanyId: this.currentChatRoom.receiverCompanyId || 0
      }
      if (loadDir === 'down') {
        temp.maxMsgId =
          this.messageList[this.messageList.length - 1]?.msgId || ''
      } else {
        temp.minMsgId = this.messageList[0]?.msgId || ''
      }

      this.getChatMessageInChatroomApi(temp, this.projectId, this.bidderId)
        .then(res => {
          const temp = (res?.data || [])
            .reverse()
            .map(value => {
              if (this.messageObject[value.msgId]) {
                return undefined
              } else {
                this.messageObject[value.msgId] = value.msgId
                return value
              }
            })
            .filter(value => value)

          if (loadDir === 'down') {
            this.messageList.push(...temp)

            // 判断是否需要展示“回到底部按钮”
            if (temp.length) {
              const scrollHeight = this.$refs.chatContentScroll.wrap
                .scrollHeight
              const viewportHeight = this.$refs.chatContentScroll.wrap
                .clientHeight
              const scrollTop = this.$refs.chatContentScroll.wrap.scrollTop

              if (
                scrollHeight >
                  viewportHeight + scrollTop + this.scrollErrorValue &&
                !self
              ) {
                this.showNewBtn = true
              } else {
                this.controlChatScrollFun()
              }
            }
          } else {
            this.messageList.unshift(...temp)
            // 渲染数据前元素的滚动高度与渲染完成后的差值，进行定位
            // 可能会受到up数据的影响
            const beforeScrollHeight = this.$refs.chatContentScroll.wrap
              .scrollHeight
            this.$nextTick(() => {
              this.$refs.chatContentScroll.wrap.scrollTop =
                this.$refs.chatContentScroll.wrap.scrollHeight -
                beforeScrollHeight
            })
          }

          this.setMessageRead(res.data || [])
        })
        .catch(err => {})
        .finally(() => {
          this.historyLoading = false
        })
    },

    /**
     * 设置消息已读：目前逻辑只在弹窗显示和隐藏时触发
     */
    setMessageRead(data) {
      const temp = (data || [])
        .filter(value => {
          return !value.isRead && value.senderCompanyId !== this.companyId
        })
        .map(value => {
          return {
            msgId: value.msgId,
            sendId: value.sendId
          }
        })

      if (!temp.length) return

      this.setMessageReadInChatroomApi(temp, this.projectId, this.bidderId)
        .then(res => {})
        .catch(err => {})
    },

    /**
     * 发送消息
     */
    sendMessage(msgType = 1) {
      // 判断发送的消息里面是否有img
      if (msgType === 1 && /<img/g.test(this.messageText)) {
        try {
          const iframe = document?.querySelector(
            '.edui-editor-iframeholder iframe'
          )
          const imgList = Array.from(
            iframe?.contentWindow?.document.body.querySelectorAll('img') || []
          )
          const messageHtml = new DOMParser().parseFromString(
            this.messageText,
            'text/html'
          )
          const messageImgList = messageHtml.querySelectorAll('img')
          imgList.forEach((value, index) => {
            messageImgList[index].style.height = value.clientHeight
          })

          this.messageText = messageHtml.body.innerHTML || this.messageText
        } catch (e) {
          //
        }
      }

      // 生成消息传参
      const data = {
        msgType: msgType, // 目前写死为文字类型的消息；1：为普通文字，2为附件
        msgSessionType: this.currentChatRoom.msgSessionType,
        receiverCompanyId: this.currentChatRoom.receiverCompanyId
      }
      if (msgType === 1) {
        data.msgContent = this.messageText
      } else {
        data.attachmentId = this.messageAttachmentId
      }

      this.sendMessageInChatroomApi(data, this.projectId, this.bidderId)
        .then(res => {
          this.messageText = ''
          this.messageAttachmentId = ''

          // 先暂停轮询
          this.timer && clearTimeout(this.timer)
          this.getMessageList('down', true)
          // 请求完之后，重启轮询
          this.loopFun()
        })
        .catch(err => {
          this.$message.error(err?.message || '消息发送失败')
        })
    },

    /**
     * 控制对话窗口滚动的函数, 滚动到最底部
     * @param duration 若不需要动画，则传0
     */
    controlChatScrollFun(duration = 200) {
      this.$nextTick(() => {
        const scrollHeight = this.$refs.chatContentScroll.wrap.scrollHeight
        const viewportHeight = this.$refs.chatContentScroll.wrap.clientHeight
        const distance = scrollHeight - viewportHeight

        if (duration) {
          scrollMainTo(this.$refs.chatContentScroll.wrap, distance, duration)
        } else {
          this.$refs.chatContentScroll.wrap.scrollTop = distance
        }
      })
    },

    /**
     * 监听对话内容区的滚动
     */
    scrollListener() {
      const scrollHeight = this.$refs.chatContentScroll.wrap.scrollHeight
      const viewportHeight = this.$refs.chatContentScroll.wrap.clientHeight
      const scrollTop = this.$refs.chatContentScroll.wrap.scrollTop

      if (scrollTop === 0) {
        this.getMessageList('up')
      }
      if (scrollHeight <= viewportHeight + scrollTop + this.scrollErrorValue) {
        this.showNewBtn = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chatroom-btn {
  font-size: 22px;
  background-color: transparent;

  &.dark {
    color: #27d8fe !important;
    border-color: #27d8fe !important;
  }

  &.light {
    color: $primary-color !important;
    border-color: $primary-color !important;
  }
}

::v-deep .el-dialog {
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.4);

  .el-dialog__header {
    padding: 16px;
    border-bottom: 1px solid $info-fourth-color;
  }
  .el-dialog__body {
    background-color: $info-fifth-color;
    padding: 0;
  }
}

.dialog-title {
  width: 334px;
  border-right: 1px solid $info-fourth-color;
}

.dialog-content {
  .content-left {
    width: 350px;
    height: 76.7vh;
    background-color: $white-color;

    .chat-partner {
      height: 70px;
      padding: 16px 24px;
      cursor: pointer;

      &:hover {
        background-color: $info-fifth-color;
      }
      &.active {
        background-color: $info-fourth-color !important;
      }
    }

    ::v-deep .el-badge sup {
      top: 0em !important;
    }
  }

  // 对话框样式
  .content-right {
    ::v-deep .el-scrollbar {
      position: relative;
      height: 63vh;

      .news-btn {
        position: absolute;
        right: 0;
        bottom: 32px;
        height: 40px;
        width: 124px;
        color: $primary-color;
        border-radius: 20px 0 0 20px;
        background-color: $white-color;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        cursor: pointer;
      }

      .history-loading {
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .chat-content {
      position: relative;
      padding: 1px 16px 16px;
      color: $text-color;

      .send-time {
        font-size: 12px;
        margin-top: 20px;
        text-align: center;
        color: $third-text-color;
      }

      .chat-bubble {
        margin-top: 20px;

        // 自己发送的消息展示在右侧
        &.self {
          direction: rtl;

          .avatar {
            margin-right: 0;
            margin-left: 14px;
          }

          .send-message {
            direction: ltr;
            background-color: $primary-third-color;
          }
        }

        .avatar {
          width: 42px;
          height: 42px;
          border-radius: 4px;
          font-size: 22px;
          color: $white-color;
          margin-right: 14px;
          flex-shrink: 0;

          &.supplier-bg {
            background-color: #36cfc9;
          }
          &.purchaser-bg {
            background-color: $primary-color;
          }
        }

        .send-message {
          display: inline-block;
          min-width: 20px;
          max-width: 520px;
          padding: 12px 18px;
          word-break: break-all;
          background-color: $white-color;
          border-radius: 0px 4px 4px 4px;
          line-height: 1.5;
          font-size: 16px;

          ::v-deep p {
            margin: 0;
          }

          ::v-deep img {
            cursor: pointer !important;
            max-width: 400px;
            max-height: 400px;
          }
        }
      }
    }

    .chat-input {
      padding-bottom: 12px;
      border-top: 1px solid $info-third-color;
      height: 13.7vh;
      overflow: hidden;

      ::v-deep .el-scrollbar {
        .el-scrollbar__view {
          display: flex;
          flex-direction: column;
          min-height: 100%;
        }
      }

      .self-input {
        outline: none;
        line-height: 1.5;
        flex: 1;
        background-color: transparent;
        cursor: text;

        ::v-deep .edui-editor {
          border: none;
          background-color: transparent;
        }
      }
    }
  }
}
</style>
<style>
#edui_fixedlayer {
  z-index: 2020 !important;
}
</style>
